import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点推荐</h2>
          <p className="text-sm text-foreground-600">本月编辑精选专题，陪你度过每一个春夜</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.slice(0, 2).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }}
              className="group block rounded-2xl overflow-hidden bg-background-50 transition-all duration-300 hover:bg-background-200/70 cursor-pointer sm:col-span-2 lg:col-span-2"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 h-48 lg:h-auto">
                  <div className="relative w-full h-full">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/10 via-transparent to-transparent"></div>
                  </div>
                </div>
                <div className="lg:w-1/2 p-5 md:p-6 flex flex-col justify-center">
                  <p className="text-xs text-primary-500 font-medium mb-2">{item.subtitle}</p>
                  <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-3">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
                </div>
              </div>
            </a>
          ))}
          {carouselItems.slice(2).map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" }); }}
              className="group block rounded-2xl overflow-hidden bg-background-50 transition-all duration-300 hover:bg-background-200/70 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <div className="relative w-full h-full">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                </div>
              </div>
              <div className="p-5">
                <p className="text-xs text-primary-500 font-medium mb-1">{item.subtitle}</p>
                <h3 className="text-base font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}